import React from "react";
import { Espacios } from "../Components/Espacios/Espacios";
import { Contact } from "../Components/Contact/Contact";
import { Footer } from "../Components/Footer/Footer";
import { Navbar } from "../Components/Navbar/Navbar";
import { Office } from "../Components/Office/Office";
import { Planes } from "../Components/Planes/Planes";
import { Slider } from "../Components/Slider/Slider";
import style from "./Landing.module.css";
import back from "../Assets/backRaro.png";
export const Landing = () => {
  return (
    <div className={style.container}>
      <div>
        <img src={back} alt="" className={style.back} />
      </div>
      <Navbar></Navbar>
      <Slider></Slider>
      <Espacios></Espacios>
      <Planes></Planes>
      <Office></Office>
      <Contact></Contact>
      <Footer></Footer>
    </div>
  );
};
